"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAIL_MAGAZINE_CONSENT_RAW_NAME = void 0;
var mobx_1 = require("mobx");
var abstract_input_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input/abstract_input_store"));
var mail_magazine_consent_input_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/input/mail_magazine_consent_input"));
exports.MAIL_MAGAZINE_CONSENT_RAW_NAME = 'permit_mail_magazine';
var MailMagazineConsentInputStore = /** @class */ (function (_super) {
    __extends(MailMagazineConsentInputStore, _super);
    function MailMagazineConsentInputStore(props) {
        var _this = _super.call(this, {
            type: props.type,
            label: props.label,
            name: props.name,
            rawName: exports.MAIL_MAGAZINE_CONSENT_RAW_NAME,
            necessary: false,
            preCheck: false
        }) || this;
        _this.component = mail_magazine_consent_input_1.default;
        _this.unwrapped = true;
        _this.handleChange = function (event) {
            _this.value = event.target.checked;
        };
        _this.value = props.checked;
        return _this;
    }
    Object.defineProperty(MailMagazineConsentInputStore.prototype, "checked", {
        get: function () {
            return this.value === true;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], MailMagazineConsentInputStore.prototype, "checked", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], MailMagazineConsentInputStore.prototype, "handleChange", void 0);
    return MailMagazineConsentInputStore;
}(abstract_input_store_1.default));
exports.default = MailMagazineConsentInputStore;
